import request from './axios'
import { baseUrl } from './config'

// 商城公众号获取签名
export const getWxSign = (param) => request({
    url: baseUrl + '/shop/customer/info/getWxSign',
    meta: { isToken: false },
    method: 'post',
    params: param
})

// 微信公众号授权code
export const getWechatCodeUrl = (paramData) => request({
    url: baseUrl + '/core/sys/auth/getWechatCodeUrl',
    meta: { isToken: false },
    method: 'post',
    data: paramData
})

// 获取unionId
export const getWechatOpenId = (paramData) => request({
    url: baseUrl + '/core/sys/auth/getWechatOpenId',
    meta: { isToken: false },
    method: 'post',
    params: paramData
})

// 判断领取积分 1-可领取 2-匹配的商城账号和其他微信号绑定 3-已领取新人福利 4-未关联账号 5-未注册
export const apiJudgeWelfare = (param) => request({
    url: baseUrl + '/shop/customer/info/judgeWelfare',
    method: 'get',
    params: param,
})

// 新人领取福利
export const apiGetWelfare = (param) => request({
    url: baseUrl + '/shop/customer/info/getWelfare',
    method: 'get',
    params: param,
})

// 发送验证码
export const apiSendCode = (paramData) => request({
    url: baseUrl + '/core/sys/auth/sendCode',
    meta: { isToken: false },
    method: 'post',
    params: paramData
})

// 检查手机号和编码
export const checkPhoneCode = (paramData) => request({
    url: baseUrl + '/core/sys/auth/checkPhoneCode',
    meta: { isToken: false },
    method: 'post',
    params: paramData
})

// 根据id获取任务信息
export const getMissionById = (param) => request({
    url: baseUrl + '/shop/mission/info/getMissionById',
    meta: { isToken: false },
    method: 'get',
    params: param
})
